import BadgeDetailController from './badge.detail.controller';

export default {
    template: require('./badge.detail.html'),
    controller: BadgeDetailController
};
